export default "__VITE_ASSET__D061IDr9__"